<mat-toolbar color="primary" class="item-panel-toolbar">
    <span>Contact Codes</span>
    <span class="toolbar-spacer"></span>
    <app-contact-type-list [contact]="contact" (selected)="selectType($event)"></app-contact-type-list>
    <app-user-selection style="margin-left: 20px;margin-top: 5px;" (selected)="selectUser($event)" [label]="'Prestataire'" [user]="user" [mode]="'list'" [userClass]="'SNItem.SNUser.CNUser.CNHealthAgent'"></app-user-selection>
    <mat-form-field style="margin-left: 20px;margin-top: 5px;" class="field-medium">
        <mat-label>Date de la consultation</mat-label>
        <input matInput [value]="contact.date" (dateChange)="contact.date = $event.value" [matDatepicker]="pickerEnd">
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>
</mat-toolbar>
<mat-dialog-content>
    <div fxLayout="row" style="min-height:60vh;max-height:60vh;overflow-y: scroll;">
        <div fxFlex="400px" class="contact-services-panel" style="min-height:60vh;max-height:60vh;">
            <app-contact-services [codes]="contact.contactService?.serviceCodes" (action)="codeAction($event)" class="contact-services"></app-contact-services>
        </div>
        <div fxFlex="400px" class="contact-services-panel" style="min-height:60vh;max-height:60vh;overflow-y: scroll;">
            <app-contact-services-panel (action)="codeAction($event)"></app-contact-services-panel>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-stroked-button (click)="close()">Fermer</button>
    <button mat-button mat-stroked-button (click)="save()">Sauvegarder</button>
</mat-dialog-actions>